module.exports = __webpack_public_path__ + "static/cover-large-2-52dc5ab3cafef173bd686c6e6481d44e.jpg";